import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import type { StaticSolanaBlockchainConfig } from "../types"

/** ponytail: swap when real marketplace program is known */
export const SOLANA_MARKETPLACE_PROGRAM_PLACEHOLDER =
  "Cni3JRmUwkugWpqpdR7GRRPvBFxoVd6sd43KKZaF9hax"

/** ponytail: devnet-discovered Market identifier; replace for mainnet deployment */
export const SOLANA_MARKET_IDENTIFIER_PLACEHOLDER =
  "DoAKMJLxyKJMrmTWNJAfqhoYKXg5VP4RDsX3d7Pu7JZR"

export const solanaMainnetConfig: StaticSolanaBlockchainConfig = {
  name: "Solana",
  isEvm: false,
  icon: "/images/blockchains/solana.svg",
  chainId: "solana:mainnet",
  blockchain: Blockchain.SOLANA,
  marketProgramAddress: "EdFEkARuYyR11Tt4eWzAYWRYZVmd3oXUYMi6pigui3fC",
  marketIdentifier: "5x8v7sz3tt3N3hGmKeJeHprJnVuQEGkCpPTa3Zi9U1rF",
  unionApi: "https://api.rarible.org",
  rpcUrls: [
    {
      url: "https://mainnet.helius-rpc.com/?api-key=a030e6e5-92df-484a-a4eb-5ac24b5af318",
      isPublic: true,
    },
  ],
  primaryCurrency: {
    id: toCurrencyId("SOLANA:So11111111111111111111111111111111111111112"),
    symbol: "SOL",
    name: "Solana",
    decimals: 9,
  },
  blockExplorers: [
    {
      url: "https://explorer.solana.com",
      icon: "/images/scanner.svg",
      adress: "https://explorer.solana.com/address/${adrress}",
    },
  ],
  isTestnet: false,
  hasStabilityProtocol: false,
}

export const solanaDevnetConfig: StaticSolanaBlockchainConfig = {
  name: "Solana",
  isEvm: false,
  icon: "/images/blockchains/solana.svg",
  chainId: "solana:devnet",
  blockchain: Blockchain.SOLANA,
  marketProgramAddress: "Cni3JRmUwkugWpqpdR7GRRPvBFxoVd6sd43KKZaF9hax",
  marketIdentifier: SOLANA_MARKET_IDENTIFIER_PLACEHOLDER,
  unionApi: "https://testnet-api.rarible.org",
  rpcUrls: [
    {
      url: "https://devnet.helius-rpc.com/?api-key=a030e6e5-92df-484a-a4eb-5ac24b5af318",
      isPublic: true,
    },
  ],
  primaryCurrency: {
    id: toCurrencyId("SOLANA:So11111111111111111111111111111111111111112"),
    symbol: "SOL",
    name: "Solana",
    decimals: 9,
  },
  blockExplorers: [
    {
      url: "https://explorer.solana.com/?cluster=devnet",
      icon: "/images/scanner.svg",
      adress: "https://explorer.solana.com/address/${adrress}?cluster=devnet",
    },
  ],
  isTestnet: true,
  hasStabilityProtocol: false,
}

export function getSolanaConfig(
  hostEnvironment: "mainnet" | "testnet" | "dev" | "beta",
): StaticSolanaBlockchainConfig {
  switch (hostEnvironment) {
    case "mainnet":
      return solanaMainnetConfig
    case "beta":
      return solanaMainnetConfig
    case "testnet":
      return solanaDevnetConfig
    case "dev":
      return solanaDevnetConfig
  }
}
